// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@media(min-width: 768px) and (max-width: 991px){
    .video-parent{
        height: 60vh!important;
    }
    .video-parent .video-text-holder{
        justify-content: end!important;
        align-items: start!important;
        padding-bottom: 120px;
        margin-top: 0!important;
        /* padding-left: 72px; */
        padding-left: 64px;

    }
    html[dir='rtl'] .video-parent .video-text-holder{
        padding-left: unset;
        padding-right: 64px;
    }
    .video-text-holder p{
        max-width: 75% !important;
        text-align: justify !important;
        font-size: 1.125rem !important;
        word-spacing: 1px;
    }
    .video-text-holder h3{
        text-align: start!important;
        font-size: 40px;
    }

    .video-parent .video-text-holder > div{
        width: 100!important;
    }
}


@media(max-width:767px){
    .ellanse .video-text-holder,
    .lanluma .video-text-holder,
    .dimono .video-text-holder,
    .maili .video-text-holder,
    .drcyj .video-text-holder,
    .juvelook .video-text-holder,
    .ksurgery .video-text-holder,
    .lenisna .video-text-holder,
    .renee .video-text-holder
    {
        margin-top: 0!important;
    }
    .basic-page h2,.about-video-hero {
        font-size: 2.25rem !important;
        font-weight: 400 !important;
    }

    .basic-page a ,.basic-page button{
        width: 240px !important;
        margin: 0 auto;
        color: #AC93E1 !important;
        background-color: white;
        border-color: white;
        font-weight: 400 !important;
        border-radius: 4px;
        font-size: 14px!important;
    }

    .basic-page a:hover ,
        .basic-page button:hover {
        background-color: #AC93E1 !important;
        color: white !important;
        border-color: #AC93E1 !important;

    }
    .basic-page .video-text-holder{
       margin-top:0!important 
    }
    .basic-page .video-text-holder p, .basic-page .video-text-holder p + div ,  
    .basic-page .video-text-holder a,
    .basic-page .video-text-holder button{
        margin-top: 8px!important;
        margin-left: auto;
        margin-right: auto;
    }
    .basic-page .video-text-holder p + div{
        margin-left: auto;
        margin-right: auto;
    }
   

  
}`, "",{"version":3,"sources":["webpack://./src/layout/components/VideoHero.css"],"names":[],"mappings":"AAAA;IACI;QACI,sBAAsB;IAC1B;IACA;QACI,8BAA8B;QAC9B,4BAA4B;QAC5B,qBAAqB;QACrB,uBAAuB;QACvB,wBAAwB;QACxB,kBAAkB;;IAEtB;IACA;QACI,mBAAmB;QACnB,mBAAmB;IACvB;IACA;QACI,yBAAyB;QACzB,8BAA8B;QAC9B,8BAA8B;QAC9B,iBAAiB;IACrB;IACA;QACI,2BAA2B;QAC3B,eAAe;IACnB;;IAEA;QACI,oBAAoB;IACxB;AACJ;;;AAGA;IACI;;;;;;;;;;QAUI,uBAAuB;IAC3B;IACA;QACI,6BAA6B;QAC7B,2BAA2B;IAC/B;;IAEA;QACI,uBAAuB;QACvB,cAAc;QACd,yBAAyB;QACzB,uBAAuB;QACvB,mBAAmB;QACnB,2BAA2B;QAC3B,kBAAkB;QAClB,yBAAyB;IAC7B;;IAEA;;QAEI,oCAAoC;QACpC,uBAAuB;QACvB,gCAAgC;;IAEpC;IACA;OACG;IACH;IACA;;;QAGI,yBAAyB;QACzB,iBAAiB;QACjB,kBAAkB;IACtB;IACA;QACI,iBAAiB;QACjB,kBAAkB;IACtB;;;;AAIJ","sourcesContent":["@media(min-width: 768px) and (max-width: 991px){\n    .video-parent{\n        height: 60vh!important;\n    }\n    .video-parent .video-text-holder{\n        justify-content: end!important;\n        align-items: start!important;\n        padding-bottom: 120px;\n        margin-top: 0!important;\n        /* padding-left: 72px; */\n        padding-left: 64px;\n\n    }\n    html[dir='rtl'] .video-parent .video-text-holder{\n        padding-left: unset;\n        padding-right: 64px;\n    }\n    .video-text-holder p{\n        max-width: 75% !important;\n        text-align: justify !important;\n        font-size: 1.125rem !important;\n        word-spacing: 1px;\n    }\n    .video-text-holder h3{\n        text-align: start!important;\n        font-size: 40px;\n    }\n\n    .video-parent .video-text-holder > div{\n        width: 100!important;\n    }\n}\n\n\n@media(max-width:767px){\n    .ellanse .video-text-holder,\n    .lanluma .video-text-holder,\n    .dimono .video-text-holder,\n    .maili .video-text-holder,\n    .drcyj .video-text-holder,\n    .juvelook .video-text-holder,\n    .ksurgery .video-text-holder,\n    .lenisna .video-text-holder,\n    .renee .video-text-holder\n    {\n        margin-top: 0!important;\n    }\n    .basic-page h2,.about-video-hero {\n        font-size: 2.25rem !important;\n        font-weight: 400 !important;\n    }\n\n    .basic-page a ,.basic-page button{\n        width: 240px !important;\n        margin: 0 auto;\n        color: #AC93E1 !important;\n        background-color: white;\n        border-color: white;\n        font-weight: 400 !important;\n        border-radius: 4px;\n        font-size: 14px!important;\n    }\n\n    .basic-page a:hover ,\n        .basic-page button:hover {\n        background-color: #AC93E1 !important;\n        color: white !important;\n        border-color: #AC93E1 !important;\n\n    }\n    .basic-page .video-text-holder{\n       margin-top:0!important \n    }\n    .basic-page .video-text-holder p, .basic-page .video-text-holder p + div ,  \n    .basic-page .video-text-holder a,\n    .basic-page .video-text-holder button{\n        margin-top: 8px!important;\n        margin-left: auto;\n        margin-right: auto;\n    }\n    .basic-page .video-text-holder p + div{\n        margin-left: auto;\n        margin-right: auto;\n    }\n   \n\n  \n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
